import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";

export function render({ theme }) {
  const els = document.querySelectorAll(".c-menu__icon");
  const title = document.querySelector(".l-hero__title>span");
  const subtitle = document.querySelector(".c-menu__domain");
  const base = subtitle.innerText;
  const icons = [];

  els.forEach((elmt) => {
    icons.push({
      elmt,
      fill: elmt.querySelector("path").getAttribute("fill"),
      hover: false,
      rotate: gsap.timeline({ paused: true }),
      show: gsap.timeline({ paused: true, reversed: true }),
      svg: elmt.querySelector("svg"),
    });
  });

  function hoverOn(icon) {
    icon.hover = true;
    icon.rotate.play();
    if (icon.rotate.progress() == 1) {
      icon.rotate.restart();
    }
  }

  icons.forEach((icon, i) => {
    icon.rotate.to(icon.elmt, {
      duration: 2.5,
      ease: "linear",
      onComplete: () => {
        if (icon.hover) {
          icon.rotate.restart();
        }
      },
      rotateY: "360deg",
    });
    icon.show
      .to(subtitle, {
        autoAlpha: 0,
        duration: 0.3,
        ease: "Circ.easeIn",
        onComplete: () => {
          subtitle.innerText = icon.elmt.getAttribute("data-title");
        },
        y: "-50%",
      })
      .set(subtitle, {
        y: "100%",
      })
      .to(subtitle, {
        autoAlpha: 1,
        duration: 0.3,
        ease: "Circ.easeOut",
        onReverseComplete: () => {
          subtitle.innerText = base;
        },
        y: "0",
      });

    icon.elmt.addEventListener("mouseenter", () => {
      hoverOn(icon);
      icons.forEach((el) => {
        if (el.elmt != icon.elmt) {
          gsap.set(el.elmt.querySelectorAll("path"), {
            duration: 0.3,
            fill: theme.isLight() ? "black" : "white",
          });
        }
      });
      gsap.to(title, {
        color: icon.fill,
        duration: 0.3,
      });
      icon.show.restart();
    });

    icon.elmt.addEventListener("mouseleave", () => {
      icon.hover = false;
      icons.forEach((el) => {
        gsap.set(el.elmt.querySelectorAll("path"), {
          duration: 0.3,
          fill: el.fill,
        });
      });
      gsap.to(title, {
        color: theme.isLight() ? "black" : "white",
        duration: 0.3,
      });
    });

    document
      .querySelector(".c-menu__nav")
      .addEventListener("mouseleave", () => {
        icon.show.reverse();
      });
  });

  ScrollTrigger.matchMedia({
    "(max-width: 1023px)": function () {
      document.addEventListener("enter", () => {
        let index = 0;
        trigger(index);
        setInterval(() => {
          trigger(index);
        }, 2000);

        function trigger(i) {
          const mouseenter = new Event("mouseenter");
          const mouseleave = new Event("mouseleave");

          (icons[i - 1]?.elmt || icons[icons.length - 1].elmt).dispatchEvent(
            mouseleave
          );
          icons[i].elmt.dispatchEvent(mouseenter);

          index = index >= icons.length - 1 ? 0 : index + 1;
        }
      });
    },
  });
}
